import { render, staticRenderFns } from "./FormGroupInput.vue?vue&type=template&id=6160c847"
import script from "./FormGroupInput.vue?vue&type=script&lang=js"
export * from "./FormGroupInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports